import { render, staticRenderFns } from "./DatadogScript.vue?vue&type=template&id=e10fee5c"
import script from "./DatadogScript.vue?vue&type=script&lang=ts"
export * from "./DatadogScript.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports